module.exports = __webpack_public_path__ + "img/badges.bf84805b.svg";